import { Col, Row } from "antd";
import CopyableContent from "../../../../components/copyableContent";
import TaxCaseStore from "../../../../contexts/taxCaseStore";
import TaxFlowStore from "../../../../contexts/taxFlowStore";
import _t from "../../../../lang/translate";
import format from "../../../../utilities/formatNumbers";

const int = (num: any) => format.integer(num)

export default function RegistrationFee() {
  const { taxCase } = TaxCaseStore.useContainer()
  const { taxFlow } = TaxFlowStore.useContainer()
  const tradePrice = taxFlow.tradePrice?.tradePrice
  const newPrice = taxFlow.newPrice?.newPrice
  const output = taxFlow.registrationFee?.output
  const isNew = taxCase.vehicle?.isNew
  const isMC = taxCase.vehicle?.typeId === 3;


  return (
    <div className="p-1 border-light border-radius">
      <h3>Registreringsafgiftsberegner</h3>
      <div className='border-light border-radius'>
        {isNew ? (
          <>
            <Field bold label={_t("new_price")} value={int(output?.config?.newPrice)} />
            <Field label={_t("registration_fee")} value={"-" + int(output?.result?.taxAfterAllDeductions)} />
            <Field bold label={_t("taxable_value")} value={int(output?.result?.taxableValue)} />
          </>
        ) : (
          <>
            <Field bold label={_t("new_price")} value={int(newPrice)} />
            <Field bold label={_t("trade_price")} value={int(tradePrice)} />
            <Field label={_t("battery_deduction")} value={int(output?.config?.batteryDeduction)} />
            <Field label={_t("registration_fee")} value={"-" + int(output?.result?.taxAfterAllDeductions)} />
            <Field bold label={_t("taxable_value")} value={int(output?.result?.taxableValue)} />
          </>
        )}
        {output?.config?.scaleBreakRates?.map((rate, i, rates) => {
          let label = ""
          if (i === 0) {
            label += `Lav skalaknæk (${format.percent(rate.rate)} op til ${format.price(rate.limit)})`
          } else if (i === (rates.length - 1)) {
            label += `Høj skalaknæk (${format.percent(rate.rate)} over ${format.price(rates[i - 1].limit)})`
          } else {
            label += `Mellem skalaknæk (${format.percent(rate.rate)} mellem ${format.price(rates[i - 1].limit)} og ${format.price(rate.limit)})`
          }

          return (
            <Field key={rate.rate}
              label={label}
              value={int(output?.result?.scaleBreakTax?.taxes[i])}
            />
          )
        })}
        <Field bold label={_t("gross_tax")} value={int(output?.result?.scaleBreakTax?.sum)} />

        {!isMC && output?.config?.emissionRates?.map((rate, i, rates) => {
          let label = `${i + 1}. CO2-tillæg: `
          if (i === 0) {
            label += `${format.price(rate.rate)}/g`;
            if (rate.limit && rate.limit < Infinity) {
              label += ` (0-${rate.limit} g/km)`
            }
          } else if (i === (rates.length - 1)) {
            label += `${format.price(rate.rate)}/g (>${rates[i - 1].limit} g/km)`;
          } else {
            label += `${format.price(rate.rate)}/g (${rates[i - 1].limit}-${rate.limit} g/km)`;
          }

          return (
            <Field key={rate.rate}
              label={label}
              value={int(output?.config?.emissionTax?.taxes[i])}
            />
          )
        })}
        {!isMC && (
          <Field bold label={"Sum af CO2-tillæg"} value={int(output?.config?.emissionTax?.sum)} />
        )}

        <Field label={"Afgift før fradrag og indfasning"} value={int(output?.result?.taxBeforeDeduction)} />
        {!isMC && (
          <>
            <Field label={`Bundfradrag alle biler (${format.percent(output?.config?.valueLoss)} af ${int(output?.config?.baseDeductionRaw)})`}
              value={"-" + int(output?.config?.baseDeduction)} />
            <Field label={"Afgift før indfasning"} value={int(output?.result?.taxAfterBaseDeduction)} />
          </>
        )}
        <Field label={`Fradrag i afgift (${format.percent(output?.config?.phasing)} indfasning)`} value={output?.result?.taxPhasingAmount ? "-" + int(output?.result.taxPhasingAmount) : "-"} />
        {isMC ? (
          <Field label={`Bundfradrag (Nul- og lavemissionsbiler: ${format.percent(output?.config?.valueLoss)} af ${int(taxCase.vehicle?.emissionAmount === 0 ? output?.config?.baseDeductionElectricRaw : output?.config?.baseDeductionHybridRaw)})`}
            value={"-" + int(output?.result?.baseDeductionElectricActualAmount)}
          />
        ) : (
          <Field label={`Bundfradrag (Nul- og lavemissionsbiler: ${format.percent(output?.config?.valueLoss)} af ${int(taxCase.vehicle?.emissionAmount === 0 ? output?.config?.baseDeductionElectricRaw : output?.config?.baseDeductionHybridRaw)})`}
            value={"-" + int(output?.result?.baseDeductionHybridElectricActualAmount)}
          />
        )}
        <Field noBorder bold label={"Registeringsafgift"} value={int(output?.result?.taxAfterAllDeductions)} />

      </div>
    </div>
  )
}

type FieldProps = {
  label: string;
  value: string;
  bold?: boolean;
  noBorder?: boolean;
}
function Field({ label, value, bold, noBorder }: FieldProps) {

  return (
    <Row className={`${noBorder ? "" : "border-bottom"} m-0 pr-1 pl-1 pt-05 pb-05 ${bold ? "text-semibold" : ""}`}
      justify="space-between"
      align="middle"
      gutter={[8, 8]}
    >
      <Col>{label}</Col>
      <Col>
        <CopyableContent contentToCopy={value.replaceAll(".", "")}>
          {value}
        </CopyableContent>
      </Col>
    </Row>
  )
}
